import { motion, useAnimation, useInView } from "framer-motion";
import { ReactNode, useEffect, useRef } from "react";

export const AnimateOnScroll = ({
  children,
  delay = 0.25,
  duration = 0.5,
  animation = "fade-down",
  className = "",
}: {
  children: ReactNode;
  delay?: number;
  duration?: number;
  animation?: "fade-down" | "fade-up" | "blur-up";
  className?: string;
}) => {
  const ref = useRef(null);

  const isInView = useInView(ref, { once: true });

  const controls = useAnimation();

  const getAnimationStyle = () => {
    switch (animation) {
      case "fade-down":
        return {
          hidden: { opacity: 0, y: -75 },
          visible: { opacity: 1, y: 0 },
        };
      case "fade-up":
        return {
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        };
      case "blur-up":
        return {
          hidden: { opacity: 0, y: 24, filter: "blur(16px)" },
          visible: { opacity: 1, y: 0, filter: "blur(0px)" },
        };
      default:
        return {
          hidden: { opacity: 0, y: -75 },
          visible: { opacity: 1, y: 0 },
        };
    }
  };

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);

  return (
    <motion.div
      ref={ref}
      variants={getAnimationStyle()}
      initial="hidden"
      animate={controls}
      transition={{ duration: duration, delay: delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
